const Dispatcher = require('flux').Dispatcher;
module.exports = new Dispatcher();



/** WEBPACK FOOTER **
 ** ./dispatcher/dispatcher.js
 **/